module.exports = __webpack_public_path__ + "assets/certificate_pdf/Artificial Intelligence Essentials_Silicon Stone Education_2019-10-02.6932adfe.pdf";